/**
 * MSAL-specific Auth Hook
 */
import { useMsal, useIsAuthenticated } from '@azure/msal-react';

export const useAuthMsal = () => {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  
  return {
    isAuthenticated: isAuthenticated,
    authState: { isAuthenticated },
    authInstance: instance,
    accounts: accounts,
    user: accounts[0] || null,
    authenticate: async () => {
      if (!isAuthenticated) {
        await instance.loginRedirect();
      }
    }
  };
};
